const Report = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99935 8.66667V11.3333M11.3327 7.33333V11.3333M8.66602 4.66667V11.3333M5.86602 14H11.466C12.5861 14 13.1462 14 13.574 13.782C13.9503 13.5903 14.2563 13.2843 14.448 12.908C14.666 12.4802 14.666 11.9201 14.666 10.8V5.2C14.666 4.0799 14.666 3.51984 14.448 3.09202C14.2563 2.71569 13.9503 2.40973 13.574 2.21799C13.1462 2 12.5861 2 11.466 2H5.86602C4.74591 2 4.18586 2 3.75803 2.21799C3.38171 2.40973 3.07575 2.71569 2.884 3.09202C2.66602 3.51984 2.66602 4.0799 2.66602 5.2V10.8C2.66602 11.9201 2.66602 12.4802 2.884 12.908C3.07575 13.2843 3.38171 13.5903 3.75803 13.782C4.18586 14 4.74591 14 5.86602 14Z"
      stroke="#207FA8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Report;
